'use strict';

import analytics from '../analytics';
import countries from '../countries';
import login from '../login';
import dialog from '../dialog';
import modal from '../modal';
import quickview from '../quickview';
import minicart from '../minicart';
import rating from '../rating';
import searchplaceholder from '../searchplaceholder';
import tooltip from '../tooltip';
import validator from '../validator';
import slick from '../slick';
import tls from '../tls';
import video from '../video';
// import afterpay from '../afterpay';
import headerMenu from '../header-menu';
import footerSelector from '../footer-selector';
import newsletter from '../newsletter';
import newsletterModule from '../newsletter-module';
import gatedlanding from '../gatedlanding';
import pdpredesign from '../pdpredesign';
import customPDPbundle from '../customized-bundle';
import inputEntry from '../input-entry';
import wishlists from '../pages/beautystation/wishlists';
import drunkMag from '../drunk-mag';
import shipping from '../pages/checkout/shipping';
import billing from '../pages/checkout/billing';
import skiplinks from '../skiplinks';

import deTheme from '../theme';
import deSearch from '../search';

import main from '../main';

import jqueryExt from '../jquery-ext';
import cookieprivacy from '../cookieprivacy';
import captcha from '../captcha';

import '../spritespin';

jqueryExt();
cookieprivacy();
captcha();

import account from '../pages/account';
import cart from '../pages/cart';
import checkout from '../pages/checkout';
import compare from '../pages/compare';
import product from '../pages/product';
import registry from '../pages/registry';
import orderconfirmation from '../pages/order-confirm';
import search from '../pages/search';
import tutorial from '../pages/tutorial';
import storefront from '../pages/storefront';
import storelocator from '../pages/storelocator';
import checkorder from '../pages/checkorder';
import content from '../pages/content';
import promotionlanding from '../pages/promotionlanding';
import beautystation from '../pages/beautystation';
import error from '../pages/error';
import checkgiftbalance from '../pages/checkgiftbalance';

const pages = {
  account,
  cart,
  checkout,
  compare,
  product,
  registry,
  orderconfirmation,
  search,
  tutorial,
  storefront,
  storelocator,
  checkorder,
  content,
  promotionlanding,
  beautystation,
  error,
  checkgiftbalance
};

var app = {
    /**
     * Initialization of storefront logic
     */
    init: function () {

        $(document).foundation();

        if (document.cookie.length === 0) {
            $('<div></div>').addClass('browser-compatibility-alert').append($('<p></p>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }

        main.init();
        main.initializeDom();
        main.initializeEvents();
        main.backToTopHandler();
        main.minimizedHeaderHandler();
        main.resetFooterError();
        main.responsiveMegaMenu();
        main.searchMenuEvent();

        // init specific global components
        analytics.init();
        login.init();
        gatedlanding.init();
        countries.init();
        tooltip.init();
        if ($('.pt_checkout').length === 0) {
            minicart.init();
        }
        validator.init();
        rating.init();
        slick.init();
        searchplaceholder.init();
        headerMenu.init();
        skiplinks.init();
        video.init();

        if (SitePreferences.IS_MARKET_MAPPING_ENABLED) {
            footerSelector.languageSelector();
            footerSelector.countrySelector();
        }

        newsletter.newsletterHeader();
        newsletter.isNewsletterEnabled();
        newsletter.signUpFooter();
        newsletterModule.init();

        inputEntry.entry();
        main.playVideoHandler();
        pdpredesign.init();
        customPDPbundle.init();

        deTheme.init();
        deSearch.init();

        drunkMag.init();

        main.initPageSpecificModule(pages);

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }

        /*****
                initZmags();
        *****/

        // if (SitePreferences.AFTERPAY_ENABLED) {
        //     afterpay.init();
        // }

        $('body').trigger('showNewsletterModal');
        wishlists.initPDPAndCartEvents();
    }
};

// initialize app
$(function () {
    app.init();
});

// expose global app obj for 3rd party integrations
window.app = {
    quickView: quickview,
    minicart: minicart,
    user: window.User,
    SCemailUrl: window.Urls.SCemailUrl,
    Product: {},
    tagmanager: analytics.tagmanager,
    gtmInternalPromotion: analytics.gtmInternalPromotion,
    modal: modal,
    dialog: dialog,
    deTheme: deTheme
};

// expose global saveURL to support legacy Composed integration
window.saveURL = window.Urls.saveConsultationURL;
// summary scroll bar global scope
window.addSummaryScrollbar = main.addSummaryScrollbar;
window.scrollToTop = main.scrollToTop;
